export default {
  namespaced: true,
  billing: {
    title: "Billing",
  }
}